<template>
  <!-- 导航 -->
  <div id="news" class="news">
      <div class="news-block2">
        <div class="news-type">
          <div
            :class="[selectTypeId == item.id ? 'selected' : 'news-type-name']"
            v-for="item in typeList"
            :key="item.id"
            @click="getCurType(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div style="flex: 1;">
          <div
          class="news-list"
          v-for="item in pageNewsList"
          :key="item.id"
          @click="getNewsDetail(item.id)"
        >
          <div class="list-right">
            <!-- <img
              style=""
              :src="newsLogo"
              alt="图片加载中"
            > -->
            <imageView :value="item.path" style="height: 160px"></imageView>
          </div>
          <div class="list-left">
            <div class="left-name">{{ item.title }}</div>
            <div class="left-deteil">
              <span class="left-src">来源：{{ item.source }}</span>
              <span class="left-time">{{ item.time | FormatTime }}</span>
            </div>
            <div class="left-content">{{ item.info }}</div>
          </div>
        </div>
        <div class="page">
          <el-pagination
            layout="total, sizes,prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="pagination.page"
            :page-size.sync="pagination.size"
            :total="pagination.total"
            @current-change="getPageNewsList"
            @size-change="queryNewsData"
          />
        </div>
        </div>
      </div>
    </div>
</template>
<script>
const base = process.env.VUE_APP_PUBLIC_PATH;
import { getNews, getCarousel } from "@/api";
import imageView from ".././imageView.vue";
import marquee from "@/components/marquee.vue";
export default {
  name: "News",
  components: {
    marquee,
    imageView,
  },
  data() {
    return {
      noticeList: [],
      newsCover: require("@/assets/img/home/policyCover.png"),
      selectTypeId: 1,
      curType: 2, //最新资讯
      curArea: null,
      typeList: [
        {
          id: 1,
          name: "最新资讯",
          type: 2,
          area: null,
        },
        {
          id: 2,
          name: "政策申报",
          type: 3,
          area: null,
        },
        {
          id: 3,
          name: "本地资讯",
          type: 2,
          area: 1,
        },
        {
          id: 4,
          name: "本省资讯",
          type: 2,
          area: 2,
        },
        {
          id: 5,
          name: "全国资讯",
          type: 2,
          area: 3,
        },
      ],
      newsLogo: require("@/assets/img/policy/news.png"),
      imgList: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      upNewsList: [],
      pageNewsList: [],
    };
  },
  computed: {
    getDay(val) {
      return function (val) {
        let date = new Date(val);
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return day;
      };
    },

    getMonth(val) {
      return function (val) {
        let date = new Date(val);
        let year = date.getFullYear();
        var month =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        return year + "-" + month;
      };
    },
  },

  methods: {
    getNewsDetail(id) {
      this.$router.push("/News/NewsDetail/" + id);
    },
    //轮播图
    async getCarouselList(type) {
      const res = await getCarousel({
        type: type, // 2-政策咨询 3-政策申报
      });
      if (res && res.data) {
        this.imgList = res.data;
      }
    },
    async getUpNewsList(type) {
      const res = await getNews({
        type: type, //1-通知公告 3-最新资讯 ,
        areaType: "",
        current: 1,
        size: 3,
      });
      if (res && res.data) {
        if (type == 1) {
          //通知公告
          this.noticeList = res.data.records;
        } else {
          this.upNewsList = res.data.records;
        }
      }
    },
    getCurType(item) {
      this.selectTypeId = item.id;
      if(item.area){
        this.curType = null;
      }else{
        this.curType = item.type;
      }
      this.curArea = item.area;
      this.getPageNewsList();
    },
    async getPageNewsList() {
      const res = await getNews({
        type: this.curType,
        areaType: this.curArea,
        current: this.pagination.page,
        size: this.pagination.size,
      });
      if (res && res.data) {
        this.pageNewsList = res.data.records;
        this.pagination.total = res.data.total;
      }
    },
    queryNewsData() {
      (this.pagination.page = 1), this.getPageNewsList();
    },
  },
  created() {
    this.getCarouselList(4); // 通知轮播图

    this.getUpNewsList(1); //通知公告
    this.getUpNewsList(3); //最新资讯
    this.getPageNewsList();
  },
  mounted() {
  },
};
</script>
<style scoped>
.news {
 padding: 28px 0px 20px 0px; 
 width:1500px;
 margin: 0 auto;
}

.news .title {
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  padding: 30px 0;
  letter-spacing: 0.3px;
}
.title-eng {
  color: #cecdcd;
  margin-left: 20px;
}
.roll-text {
  margin-right: 20px;
}
.carousel {
  width: 25%;
  float: left;
  height: 260px;
}
.cover-right {
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 25px;
  width: 75%;
  height: 260px;
}
.news-item {
  display: inline-flex;
  justify-content: space-between;
  cursor: pointer;
}
.new-date {
  background-color: #f6f6fa;
  color: #878894;
  padding: 2px 10px;
}
.date-day {
  display: block;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  padding-top: 12px;
}
.date-month {
  display: block;
  font-size: 12px;
  text-align: center;
  padding: 10px 0;
}
.news-content {
  width: calc(100% - 90px);
  margin-left: 20px;
}
.news-title {
  font-size: 18px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 15px;
}
.news-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
  height: 20px;
  line-height: 20px;
}

.news-block2 {
  width: 100%;
  display: flex;
}
.news-type {
  width: 200px;
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-weight: bold;
  margin: 0px 20px 70px 0;
  color: black;
  background-color: #fff;
  border-radius: 16px;
}
.news-type-name {
  display: flex;
  width: 200px;
  height: 50px;
  padding: 10px 18px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #939499;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.selected {
  display: flex;
  width: 200px;
  height: 50px;
  padding: 10px 18px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #2a66e7;
  /* background: #eaf1ff; */
  /* border-radius: 12px; */
  font-weight: bold;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.news-list {
  display: block;
  padding: 20px ;
  cursor: pointer;
  background-color: white;
  border-radius: 16px;
  margin-bottom: 20px;
  box-shadow: 0px 5px 5px 0px rgba(54, 97, 167, 0.05);
}
.list-right {
  display: inline-block;
  height: 160px;
  width: 23%;
  margin-right: 2%;
}
.list-right img {
  height: 160px;
  width: 100%;
  object-fit: cover;
}
.list-left {
  float: right;
  height: 160px;
  width: 75%;
  position: relative;
}
.left-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}
.left-content {
  font-size: 16px;
  line-height: 23px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-align: justify;
  word-break: break-all;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}
.left-deteil {
  font-size: 16px;
  color: #AEAEAE;
  margin: 20px 0;
}
.left-sr {
  position: absolute;
  left: 0;
}
.left-time {
  margin-left: 15px;
  /* position: absolute;
  right: 0; */
}

.page {
  padding: 10px 10px;
  height: 50px;
  /* background-color: #fff; */
  text-align: right;
}
@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
@media screen and (max-width: 767px) {
  .news .content {
    margin-left: 0;
  }
  .news .container {
    margin-top: 0;
  }
}
</style>
